module.exports = __webpack_public_path__ + "u1.no2.215b6161.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/u1.no2.jpg
// module id = Gqth
// module chunks = 0